import React from "react";
import { UseFormRegister } from "react-hook-form";
import classes from "./CheckboxSelector.module.scss";

const CheckboxSelector = (props: {
  namespace: string;
  options: string[];
  register: UseFormRegister<any>;
}) => {
  return (
    <div className={classes.CheckboxSelector}>
      {props.options.map((option: string) => (
        <div key={option} className={classes.optionContainer}>
          <input
            {...props.register(props.namespace, { required: true })}
            type="checkbox"
            value={option}
            id={option}
          />
          <label htmlFor={option}>{option}</label>
        </div>
      ))}
    </div>
  );
};

export default CheckboxSelector;
